import semver from 'semver';
import {ModelMigration} from '@/engine/types/model/migration';

export type MigrationsToRunResult =
  | {success: true; migrations: ModelMigration[]; finalVersion: string}
  | {success: false; error: 'invalid-version' | 'target-should-be-higher'};

export const buildMigrationsToRun = (
  migrations: ModelMigration[],
  fromVersion: string,
  toVersion: string,
): MigrationsToRunResult => {
  if (!semver.valid(fromVersion) || !semver.valid(toVersion)) {
    return {success: false, error: 'invalid-version'};
  }

  if (semver.eq(fromVersion, toVersion)) {
    return {success: true, migrations: [], finalVersion: toVersion};
  }

  if (!semver.lt(fromVersion, toVersion)) {
    return {success: false, error: 'target-should-be-higher'};
  }

  const chain = migrations
    .filter(({to}) => semver.gt(to, fromVersion) && semver.lte(to, toVersion))
    .sort((a, b) => semver.compare(a.from, b.from));

  return {success: true, migrations: chain, finalVersion: toVersion};
};
